import ApplicationSerializer from './application';
import { isEmpty } from '@ember/utils';

export default ApplicationSerializer.extend({
  isNewSerializerAPI: true,

  normalize(type, hash, prop) {
    hash.journey_subject_id = isEmpty(hash.subject_id) ? null : hash.subject_id;
    delete hash.subject_id;
    return this._super(type, hash, prop);
  },

  // 'trigger' is a private method on DS.Model,
  // so we use broadcastTrigger for the relationships instead.
  attrs: {
    broadcastTrigger: 'trigger_id',
  },
});
